import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';

export class CreditInvoice extends ModelBase {
  constructor() {
    super();
  }

  totalAmount: Money;
  netAmount: Money;
  vatAmount: Money;
  invoiceNumber: string;
  refersToPeriod: string;

  toJSON() {
    return this;
  }
}

export class CreditInvoiceRowModel {
  id: string;
  correction: Money;
  isRounding: boolean;
  description: string;
  invoicedAmount: Money;
  creditedAmount: Money;
  vatAmount: Money;
  paidAmount: Money;
  notCreditedAmount: Money;
  balance: Money;
}

export class CreditInvoiceModel {
  invoiceId: string;
  rows: CreditInvoiceRowModel[];
  leaseAgreementId: string;
  changeAccountingDate: boolean;
  verificationDescription: string;
  verificationBusinessTransactionDate: LocalDate;
}

export class CreditInvoiceRowResultModel {
  id: string;
  balance: Money;
  isRounding: boolean;
}

export class CreditInvoiceResultModel {
  rows: CreditInvoiceRowResultModel[];
  errorMessage: string;
  customerBalance: Money;
}
